import * as yup from 'yup';

export const CreateProjectFormValidation = yup.object().shape({
//   description: yup.string().required('Descrição é obrigatória'),
  startdate: yup.string().required('Data de Início é obrigatória'),
  idProjectType: yup.string().required('Tipo de projecto é obrigatório'),
//   enddate: yup.string().required('Data de Fim é obrigatória'),
//   entityName: yup.string().required('Nome da Entidade é obrigatório'),
//   moneyInvested: yup.number().min(0, 'O valor deve ser positivo').required('Montante é obrigatório'),
  objectives: yup.string().required('Os objetivos são obrigatórios'),
  principalDocBase64File:  yup.mixed<File>()
  .required('O ficheiro é obrigatório')
  .test('is-file', 'Tipo de ficheiro inválido', (value): value is File => value instanceof File),
});
